import {UI} from "../../../stem-core/src/ui/UIBase.js";
import {styleRule, StyleSheet} from "../../../stem-core/src/ui/Style.js";

import {StepDescription} from "./StepDescription.jsx";
import {authService} from "../../../client/connection/Services.js";
import {DONATE_PAGE_URLS} from "../PanelConstants.js";
import {Messages} from "../../Messages.js";
import {MerchantButton} from "../../common/MerchantButton.jsx";
import {PanelChooseCard} from "../pages/panels/donation/components/PanelChooseCard.jsx";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme.js";
import {PoweredByBlink} from "../PoweredByBlink.jsx";
import {PaymentMethodStore} from "../../State.js";
import {LoadingSpinner} from "../../../core/ui/LoadingSpinner.jsx";
import {Flow} from "../initializeFlows.js";


class PayWithChosenCardPanelStyle extends StyleSheet {
    @styleRule
    title = this.themeProps.PANEL_TITLE;
}

@registerStyle(PayWithChosenCardPanelStyle)
export class PayWithChosenCardPanel extends UI.Element {
    render() {
        const {styleSheet} = this;

        return [
            <StepDescription backFunction={() => this.options.changeURL(authService.isAuthenticated() ?
                                    DONATE_PAGE_URLS.donate : DONATE_PAGE_URLS.auth, true)}
                             currentStep={StepDescription.stepCount} stepDescription={Messages.paymentStep}/>,
            <div className={styleSheet.title}>{Messages.paymentDetails}</div>,
            <PanelChooseCard hideActiveCard={true} addCardButtonLabel={Messages.addNewCard} ref="chooseCard"
                             selected={PaymentMethodStore.getPrimary()} onCardSelected={() => this.redraw()}
                             onAddCard={() => this.options.changeURL(DONATE_PAGE_URLS.payWithAddedCard)}/>,
            <MerchantButton disabled={this.chooseCard && !this.chooseCard.getActive()}
                            onClick={() => this.donate()}>
                {Messages.finalizePayment}
            </MerchantButton>,
            <PoweredByBlink />,
        ]
    }

    donate() {
        LoadingSpinner.show();

        const preferredPaymentMethodId = this.chooseCard.getActive().id;
        const payload = {
            amount: Flow.donation.getTotalAmount(),
            frequency: Flow.donation.getFrequency(),
            preferredPaymentMethodId,
            coversFees: Flow.donation.payDonationFeeCheckboxChecked,
        };
        Flow.donation.setPayload(payload);
        Flow.donation.donate(() => this.options.changeURL(DONATE_PAGE_URLS.thankYou),
            () => this.options.changeURL(DONATE_PAGE_URLS.paymentFailed, true));
    }

    onMount() {
        authService.onAuthenticationChange(() => {
            if (this.isInDocument() && !authService.isAuthenticated()) {
                this.options.changeURL(DONATE_PAGE_URLS.donate, true);
            }
        });
    }
}
